'use strict';
module.exports = require('../../full/array/find-last');
